import type { SxProps, Theme } from '@mui/material/styles';

import { signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';
import { signupResultLayoutStyles } from '../SignupResultLayout/SignupResultLayout.styles';

export const signupDomainErrorStyles = {
  accountHeading: signupPageStyles.accountHeading,
  sectionDescription: signupPageStyles.sectionDescription,
  input: signupPageStyles.input,
  emailButton: signupPageStyles.emailButton,
  actionError: signupPageStyles.actionError,
  resultMessage: signupResultLayoutStyles.resultMessage,
  resultActions: signupResultLayoutStyles.resultActions,
  inlineResult: signupResultLayoutStyles.inlineResult,
  inlineError: (theme: Theme): SxProps<Theme> => ({
    display: 'grid',
    gridTemplateColumns: '34px 1fr',
    gap: 1.5,
    alignItems: 'start',
    my: 1.5,
    color: theme.palette.text.primary,
  }),
  errorIcon: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    width: '30px',
    height: '30px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    bgcolor: theme.palette.error.main,
    color: theme.palette.common.white,
    fontSize: signupTypography.sectionHeading,
    fontWeight: 700,
  }),
  inlineErrorTitle: (): SxProps<Theme> => ({
    fontSize: signupTypography.standard,
    fontWeight: 700,
    lineHeight: 1.4,
  }),
  inlineErrorMessage: (theme: Theme): SxProps<Theme> => ({
    mt: 0.25,
    color: theme.palette.grey[700],
    fontSize: signupTypography.standard,
    lineHeight: 1.45,
  }),
  differentMethod: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    width: '100%',
    mt: 2.5,
    pt: 2,
    borderTop: `1px solid ${theme.palette.divider}`,
    borderRadius: 0,
    color: '#147df5',
    fontSize: signupTypography.standard,
    textTransform: 'none',
    '&:focus-visible': {
      outline: '3px solid rgba(0, 144, 250, 0.35)',
      outlineOffset: '2px',
    },
  }),
};
